import { FunctionComponent } from 'react';
import { IconHandler } from '../../utils';
import { ItemCardType } from '../../types';

const ItemCard: FunctionComponent<ItemCardType> = ({
  Icon = null,
  ImageSection = null,
  header,
  muted = false,
  children,
  imgTop = false,
  footer,
}) => {
  return (
    <div className={`card-item h-100 justify-content-between${imgTop ? ' card-item-top-img' : ''}`}>
      {ImageSection ? (
        <div className={`card-item-img d-flex justify-content-center align-items-center text-muted`}>{ImageSection}</div>
      ) : Icon ? (
        <div className={`card-item-img circle${muted ? ' muted' : ''}`}>
          <IconHandler Icon={Icon} size="3em" />
        </div>
      ) : (
        <></>
      )}

      <div className="card-item-content justify-content-between">
        {header && <div className="card-item-header d-flex h-100">{header}</div>}
        <div className="card-item-body flex-column px-3 h-100">{children}</div>
        {footer && <div className="card-item-footer p-0"> {footer}</div>}
      </div>
    </div>
  );
};

export default ItemCard;
